export const adBannerProperties = {
    "adBannerDetailTextOne": " Access the company's payment history and background information on key employees",
    "adBannerDetailTextTwo": "See the company’s D&amp;B PAYDEX<sup>®</sup> Score and five other Dun &amp; Bradstreet scores and ratings",
    "adBannerDisclaimerText": "* Price valid for U.S. customers purchasing Business Information Report Snapshot on U.S. companies",
    "adBannerSubtitle": "Our Business Information Report Snapshot is a collection of business credit scores and ratings that help you gauge the financial health of your customers, suppliers, and business partners",
    "adBannerTitle": " Looking for a credit report on ",
    "cartCheckoutPath": "https://cart.dnb.com/checkout",
    "ctaLabel": "View More Details",
    "ctaLink": "https://www.dnb.com/products/small-business/business-information-report-snapshot.html",
    "dnbCartApiKey": "57b89a4446e66fb0d833d581a34df837",
    "dnbCartTokenValue": "Axi1u9YWXq7US5F",
    "formIdentifier": "UniqueFormIdentifier-oDYNaS",
    "linkCartButtonText": "Buy Now",
    "linkCartPrice": "139.99",
    "linkProductId": "14598",
    "localeLanguageTag": "en_US",
    "priceLabel": "Just $139.99 *",
    "selectedPriceId": "14846",
    "uniqueId": "PdXembe816sikVCVENO5UR0k9U3bueap",
    "quantity": 1
}